import styled from 'styled-components';

export const $InputGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  & > div:first-child input,
  & > div:first-child div {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  && > div:nth-child(2) > div > div > div > div > div:nth-child(3),
  & > div:nth-child(2) input,
  & > button:nth-child(2) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  & > div:nth-child(2) {
    flex: 2 auto;
  }

  && > * {
    margin-bottom: 0;
  }
`;
